/* Recall tracker — shapes the editorial half of the page.

   The copy is {{ page.content }}: one rich-text blob typed in the Shopify
   admin, so the server cannot mark up a contents list, a callout card or an
   accordion. This builds all three from the headings that are already there.

   THE RULE THIS FILE FOLLOWS: re-parent, never remove. Every word is in the
   DOM before this runs and is still in the DOM after, at the same heading
   level and in the same order — the outline Google sees is the server's, and
   it is identical to live's. With JS off the page is a plain article with
   everything open, which is what live is.

   Accordion state therefore starts OPEN in the markup and is collapsed here,
   not the other way round: content that has already painted must never be
   yanked away (docs/PORTING-A-CATEGORY-PAGE.md gotcha 24), and content that
   only appears if a script runs is content that can fail to appear at all. */
(function () {
  'use strict';

  var prose = document.querySelector('[data-rd-recall-prose]');
  if (!prose) return;

  var slugged = Object.create(null);

  function slug(text) {
    var s = String(text).toLowerCase().trim()
      .replace(/[‘’“”]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'section';
    // Two headings can shorten to the same slug; an anchor has to be unique
    // or the contents list sends both entries to the first one.
    if (slugged[s]) s += '-' + (++slugged[s]);
    else slugged[s] = 1;
    return s;
  }

  /* ---------------------------------------------------- 1. the FAQ accordion

     USES THE SITE'S SHARED ACCORDION — the one on the product pages, the FAQ
     page, the homepage and the encyclopedia hub. This page used to ship its
     own chevron variant (.rd-recall__faq*); it is gone, and with it the second
     visual language for the same control. Sam's call, 3 Sep.

     No toggle code here: redesign.js binds one delegated listener per
     [data-rd-accordion] container at load, and the attribute sits on the
     section wrapper, so rows built afterwards are picked up by delegation.

     THE QUESTION STAYS AN h4, in place, with its own child nodes moved into a
     button inside it — the outline is frozen. The number and the +/- carry NO
     text nodes and are drawn from CSS, because anything with text inside that
     button becomes part of the heading Google reads. */
  function buildFaq() {
    var heads = prose.querySelectorAll('h2, h3, h4, h5, h6');
    var faqHead = null;
    for (var i = 0; i < heads.length; i++) {
      if (/^faq\b/i.test((heads[i].textContent || '').trim())) { faqHead = heads[i]; break; }
    }
    if (!faqHead) return;

    faqHead.classList.add('rd-recall__faq-head');

    var items = [], node = faqHead.nextElementSibling, current = null;
    while (node) {
      var next = node.nextElementSibling;
      if (node.tagName === 'H4') {
        current = { q: node, a: [] };
        items.push(current);
      } else if (current) {
        current.a.push(node);
      }
      node = next;
    }
    if (!items.length) return;

    var wrap = document.createElement('div');
    wrap.className = 'rd-faq__list rd-recall__faq';
    faqHead.insertAdjacentElement('afterend', wrap);

    items.forEach(function (item, i) {
      var row = document.createElement('div');
      row.className = 'rd-faq__row';

      var panel = document.createElement('div');
      panel.className = 'rd-faq__body';
      panel.id = 'rd-recall-faq-' + (i + 1);
      panel.hidden = true;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rd-faq__btn';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', panel.id);

      var n = document.createElement('span');
      n.className = 'rd-faq__n';
      n.setAttribute('aria-hidden', 'true');
      n.setAttribute('data-n', (i + 1 < 10 ? '0' : '') + (i + 1));

      var mid = document.createElement('span');
      var title = document.createElement('span');
      title.className = 'rd-faq__title';
      /* Moved, not read as text — that would drop a <strong> or a link the
         admin typed inside the question. */
      while (item.q.firstChild) title.appendChild(item.q.firstChild);
      mid.appendChild(title);

      var mark = document.createElement('span');
      mark.className = 'rd-faq__mark';
      mark.setAttribute('aria-hidden', 'true');
      mark.innerHTML = '<span class="rd-faq__mark-plus"></span>' +
                       '<span class="rd-faq__mark-minus"></span>';

      btn.appendChild(n); btn.appendChild(mid); btn.appendChild(mark);
      item.q.appendChild(btn);
      item.q.classList.add('rd-faq__q');

      row.appendChild(item.q);
      item.a.forEach(function (el) { panel.appendChild(el); });
      row.appendChild(panel);
      wrap.appendChild(row);
    });
  }

  /* ------------------------------------------------- 2. the "note" callout

     One h3 on this page is a caution rather than a section. The design draws
     it as a cream card. Matched on the heading's own text so a re-ordering of
     the page cannot move the treatment onto the wrong block. */
  function buildNote() {
    var hs = prose.querySelectorAll('h3');
    for (var i = 0; i < hs.length; i++) {
      if (!/^important note/i.test((hs[i].textContent || '').trim())) continue;
      var h = hs[i], card = document.createElement('div');
      card.className = 'rd-recall__callout';
      h.insertAdjacentElement('beforebegin', card);
      card.appendChild(h);
      var n = card.nextElementSibling;
      while (n && !/^H[1-4]$/.test(n.tagName)) {
        var next = n.nextElementSibling;
        card.appendChild(n);
        n = next;
      }
      return;
    }
  }

  /* --------------------------------------------------- 3. contents + spy */
  function buildToc() {
    var aside = document.querySelector('[data-rd-recall-toc]');
    if (!aside) return;
    var nav = aside.querySelector('nav');
    if (!nav) return;

    // h2 and h3 only. The FAQ's h4s are questions, not sections, and listing
    // seven of them would bury the four headings that are.
    var heads = [].slice.call(prose.querySelectorAll('h2, h3'));
    if (heads.length < 2) return;

    var links = heads.map(function (h) {
      if (!h.id) h.id = slug(h.textContent);
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = (h.textContent || '').trim();
      a.className = 'rd-recall__toc-link';
      if (h.tagName === 'H3') a.classList.add('rd-recall__toc-link--sub');
      nav.appendChild(a);
      return a;
    });

    aside.hidden = false;

    if (!('IntersectionObserver' in window)) return;
    var seen = new Map();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { seen.set(e.target, e); });
      var best = null;
      seen.forEach(function (e) {
        if (!e.isIntersecting) return;
        if (!best || e.target.getBoundingClientRect().top < best.target.getBoundingClientRect().top) best = e;
      });
      if (!best) return;
      links.forEach(function (a) {
        a.classList.toggle('is-current', a.getAttribute('href') === '#' + best.target.id);
      });
    }, { rootMargin: '-88px 0px -70% 0px', threshold: 0 });
    heads.forEach(function (h) { io.observe(h); });
  }

  buildNote();
  buildFaq();
  buildToc();
})();
